import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const CloseButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <IconButton
      aria-label="close"
      onClick={onClick}
      sx={{
        position: "absolute",
        right: 12,
        top: 12,
        color: "#000",
      }}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default CloseButton;
